export default __webpack_public_path__ + "static/media/5.97f4be93.jpg";